var flux_1 = require('flux');
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new flux_1.Dispatcher();
//# sourceMappingURL=dispatcher.js.map